export default __webpack_public_path__ + "static/media/Zing 2.1.ca1b0545.gif";